import { CheckCircleIcon } from '@synoptic/ui-kit/icons/react/check-circle.js';
import { FC } from 'react';
import { StripeBillingInterval } from '@/__generated__/graphql';
import {
  streamPriceLabelContainer,
  streamPriceLabelHighlighted,
  streamPriceLabelUnlockedPrice,
} from '@/components/streams/stream-tag/stream-price-label.css.ts';
import { formatIntervalShort } from '@/utils/paid-data.ts';

export const StreamPriceLabel: FC<{
  price: number;
  isStartingPrice?: boolean;
  variant?: 'primary' | 'secondary' | 'unlocked';
  subscribed?: boolean;
  interval?: StripeBillingInterval;
  intervalCount?: number;
}> = ({
  price,
  isStartingPrice,
  variant = 'primary',
  subscribed,
  interval,
  intervalCount,
}) => {
  const intervalLabel =
    interval && intervalCount
      ? formatIntervalShort(interval, intervalCount)
      : 'month';

  return (
    <div className={streamPriceLabelContainer[variant]}>
      {variant === 'unlocked' ? (
        <CheckCircleIcon width={14} height={14} aria-hidden />
      ) : null}
      {isStartingPrice ? <span>Starting from </span> : null}
      {subscribed ? <span>Unlocked for </span> : null}
      <span
        className={
          variant === 'primary'
            ? streamPriceLabelHighlighted
            : variant === 'unlocked'
              ? streamPriceLabelUnlockedPrice
              : undefined
        }
      >
        ${price}/{intervalLabel}
      </span>
    </div>
  );
};
